import React from 'react'
import { connect } from 'react-redux'

const SelectSegment = ({ segments, dispatch, ...props }) => {
  const segmentsList = segments.map((segment, i) => 
    <option value={segment.id} key={i}>{segment.name}</option>
  )
  return (
    <select className="input select" {...props}>
      <option value="">Open saved segment</option>
      {segmentsList}
    </select>
  )
}

function mapStateToProps(state) {
  return { segments: state.segments }
}

export default connect(mapStateToProps, null)(SelectSegment)


// WEBPACK FOOTER //
// ./src/components/micro/SelectSegment.js